module.exports = __webpack_public_path__ + "img/a3.3d39b9f7.png";